<template>
    <header class="header">
        <div class="container">
            <div v-if="siteInfo" class="py-3 px-3 d-flex flex-row justify-content-between">
                <router-link to="/" class="d-flex flex-column sm-w-40 align-items-start" @click="resetLotPage">
                    <b-img :src="siteInfo.logo" :width="siteInfo.logo_width" :height="siteInfo.logo_height" :alt="siteInfo.title"/>
                    <h4 class="app-title" v-if="siteInfo && siteInfo.title">{{ siteInfo.title }}</h4>
                </router-link>
                <div v-if="siteInfo" class="sm-w-60 text-center sm-text-right">
                    <h4 class="h6">{{ siteInfo.header_name }}</h4>
                    <h5 class="app-desc">{{ siteInfo.header_desc }}</h5>
                </div>
                <div class="px-0 d-md-flex flex-column align-self-top text-right d-sm-none">
                    <p v-for="contact in contacts"
                        :key="contact.key"
                        :class="['mb-0', ...contact.classes]">
                        <template v-if="contact.links">
                            <template v-for="link in contact.links">
                                <a v-if="siteInfo[link.key]"
                                    :href="siteInfo[link.key]"
                                    class="text-success text-nowrap">
                                    <fa class="mr-2" :icon="link.icon" />
                                </a>
                            </template>
                        </template>
                        <a :href="contact.href" class="text-success text-nowrap">
                            <fa class="mr-2" :icon="contact.icon" />
                            {{contact.value}}
                        </a>
                    </p>
                </div>
            </div>
        </div>
        <div class="container px-3 px-sm-0 px-md-3 d-none d-md-block">
            <header-timer
                v-if="siteInfo"
                :time="siteTime"
                class="pl-3 float-right"
                format="dd MMMM, yyyy HH:mm:ss"
            />
            <p v-if="siteInfo" class="text-muted">
                <small>{{ siteInfo.contact_desc }}</small>
            </p>
        </div>
        <app-menu :time="siteTime"/>
    </header>
</template>

<script>
import AppMenu from "./AppMenu";
import {state} from "../../store";
import HeaderTimer from '@features/HeaderTimer/HeaderTimer'

export default {
    name: "AppHeader",
    components: { HeaderTimer, AppMenu },
    props: {
        contacts: Array,
    },
    computed: {
        siteTime() {
            return this.siteInfo?.time;
        },
        siteInfo() {
            return state.siteInfo;
        },
    },
    methods: {
        resetLotPage() {
            this.$store.commit('Lots/resetPage')
            this.$store.commit('MyLots/resetPage')
            this.$store.commit('UserLots/resetPage')
        }
    }
};
</script>
<style scoped>
    .app-desc {
        font-size: small;
    }
    @media (max-width: 576px) {
        .sm-w-30 {
            width: 30%;
        }
        .sm-w-40 {
            width: 40%;
        }
        .sm-w-60 {
            width: 60%;
        }
        .sm-w-70 {
            width: 70%;
        }
        .app-title {
            font-size: 1rem;
        }
        .sm-text-right {
            text-align: right !important;
        }
        .d-sm-none {
            display: none;
        }
    }
</style>
